<template>
  <div class="setting">
    <div class="currentRoute">
      <div class="route">
        <router-link to="/knowledgebase">知识库</router-link>
        <span>/知识检索</span>
      </div>
      <div class="chat-container">
        <!-- Right side: Chat interface -->
        <div class="chat-messages" ref="chatMessages">
          <div v-for="(item, index) in chatRecords" :key="index" :class="item.sender">
            <div class="icon">
              <img v-if="item.sender === 'user'" src="../../assets/images/userIcon.png" alt="用户头像" />
              <img v-else src="../../assets/images/robot.png" alt="AI头像" />
            </div>
            <div class="message-container">
              <div v-if="item.sender === 'ai' && extractThinkContent(item.content)" class="think">
                <div class="title">
                  <p>思考内容</p>
                  <button @click="ifshowThoughts = !ifshowThoughts"
                    :style="ifshowThoughts ? hideIcon : showIcon"></button>
                </div>
                <div v-show="ifshowThoughts" class="message" style="background-color:rgb(231, 231, 231);"
                  v-html="formatMath(extractThinkContent((item.content)))">
                </div>
              </div>
              <div class="message" style="display: flex;flex-direction: column;">
                <div class="content" v-html="formatMath(removeThinkContent(item.content))"></div>
                <div class="references" v-if="item.references">
                  <div style="font-size: 14px ;font-weight:large;">引用:</div>
                  <div style="font-size: 14px;" v-for="(reference, i) in item.references" :key="i">
                    <div class="source" style="display: flex;align-items: center;font-weight: bold;">
                      {{ extractReference(reference) }}
                      <button @click=switchShowPageContent(index,i) :style="showPageContent[index].show[i] ? hideIcon : showIcon"></button>
                    </div>
                    <div class="pageContent" v-show="showPageContent[index].show[i]">
                      {{ reference.content }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div v-show="waitingForResponse" class="ai">
            <div class="icon">
              <img src="../../assets/images/robot.png" alt="AI头像" />
            </div>
            <div class="message" style="padding-left: 30px;">AI正在生成回答...</div>
            <div class="waiting">
              <img src="../../assets/images/waitingIcon.png" alt="等待AI回复" />
            </div>
          </div>
          <!-- Display user and AI chat records -->
        </div>
        <div class="chat-input">
          <!-- User input box -->
          <textarea v-model="message" placeholder="请输入问题" @keydown="handleKeydown"></textarea>
          <div class="buttons">
            <img @click="sendUserMessage(message)" src="../../assets/images/sendMessage.png" alt="发送" />
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
//import { askOpenAI} from '@/api/ai_chat';
import { askVectorDB } from '@/api/auth';
import { marked } from 'marked';
import showIconImage from '../../assets/images/show-icon.png';
import hideIconImage from '../../assets/images/hide-icon.png';
//import MathJax from 'mathjax';

export default {
  name: 'ChatPage',
  data() {
    return {
      message: '', // User input message
      chatRecords: [], // Array to store chat records
      waitingForResponse: false, // Flag to indicate if waiting for AI response
      ai_response: '',//AI回复
      ifPushed: false,//AI回复是否已经推送
      usertimestamp: '',//用户发送消息的时间戳
      aitimestamp: '',//AI回复的时间戳
      ifNewChat: false,//是否新建聊天
      showIcon: { backgroundImage: `url(${showIconImage})` },
      hideIcon: { backgroundImage: `url(${hideIconImage})` },
      ifshowThoughts: false,//是否显示思考内容
      showPageContent: [],//显示的页面内容
    };
  },
  mounted() {
    this.pushGreeting();//推送问候语
    // 动态加载 MathJax CDN
    this.loadMathJax().then(() => {
      this.renderMath();
    });
    for (let i = 0; i < 100; i++) {
      this.showPageContent.push(
        {index: i, show: [false,false,false,false,false,false,false,false,false,false]}
      );
    }
    //console.log('showPageContent:', this.showPageContent[0].show[0]);
  },
  props: {
    currentUserId: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Add computed properties

  },
  methods: {
    extractReference(reference) {
      if (reference) {
        const parts = reference.source.split('\\');
        if (parts.length >= 3) {
          if (parts[2].split('%').length>1)
            return parts[2].split('%')[1];
          else
            return parts[2];
        }
        const parts2 = reference.source.split('/');
        if (parts2.length >= 3) {
          if (parts2[2].split('%').length>1)
            return parts2[2].split('%')[1];
          else
            return parts2[2];
        }
      }
      else {
        return '';
      }
    },
    switchShowPageContent(index,i) {
      this.$set(this.showPageContent[index].show, i, !this.showPageContent[index].show[i]);
      //console.log('index:', index);
      //console.log('showPageContent:', this.showPageContent);
    },
    extractThinkContent(text) {
      const regex = /<think>(.*?)<\/think>/gs;
      const match = regex.exec(text)
      if (match) {
        return match[1];
      }
      else {
        return '';
      }
    },
    removeThinkContent(text) {
      return text.replace(/<think>.*?<\/think>/gs, '');
    },
    pushGreeting() {
      this.chatRecords.push({
        sender: 'greeting',
        content: '欢迎来到中建八局AI智能体中心AILab~' + '\n' + '关于知识库的内容都可以问我~',
      });
    },

    formatMath(text) {//格式化数学公式
      if (!text) return '';
      const htmlContent = marked(text); // 使用 marked 解析 Markdown
      return htmlContent.replace(/\$\$(.*?)\$\$/g, (match, p1) => {
        return `\\[${p1}\\]`;
      }).replace(/\$(.*?)\$/g, (match, p1) => {
        return `\\(${p1}\\)`;
      });
    },
    loadMathJax() {
      return new Promise((resolve) => {
        if (window.MathJax) {
          resolve();
        } else {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_CHTML';
          script.onload = () => {
            window.MathJax.Hub.Config({
              tex2jax: {
                inlineMath: [['\\(', '\\)']],
                displayMath: [['\\[', '\\]']],
                processEscapes: true
              }
            });
            resolve();
          };
          document.head.appendChild(script);
        }
      });
    },
    //再帮我引用一下markdown的库

    renderMath() {
      // 渲染页面中的数学公式
      this.loadMathJax().then(() => {
        if (window.MathJax && window.MathJax.Hub) {
          window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
        }
        else {
          console.error('MathJax is not loaded');
        }
      });
    },
    scrollToBottom() {
      const container = this.$refs.chatMessages;
      container.scrollTop = container.scrollHeight;
    },
    async sendUserMessage(message) {
      // Handle sending message logic
      if (message != '') {
        // Add user message to chat records
        this.usertimestamp = new Date().getTime();
        this.chatRecords.push({
          sender: 'user',
          content: message,
          timestamp: this.usertimestamp
        });
        this.message = '';
        this.waitingForResponse = true;
        askVectorDB(this.currentUserId, this.$route.params.folderName, message).then((res) => {
          this.waitingForResponse = false;  // 停止等待
          this.aitimestamp = new Date().getTime();
          this.chatRecords.push({
            sender: 'ai',
            content: res.response.message,
            references: res.response.references,
            timestamp: this.aitimestamp,
          });

          this.renderMath();
          this.scrollToBottom();
        });

      }
    },
    //按下Enter键发送消息
    handleKeydown(event) {
      if (event.key === 'Enter') {
        // 检查是否同时按下了Ctrl键
        if (event.ctrlKey) {
          // Ctrl+Enter，插入换行
          event.preventDefault(); // 阻止默认行为
          this.message += '\n';

        } else {
          // 仅Enter，发送消息
          event.preventDefault(); // 阻止默认行为
          this.sendUserMessage(this.message);

        }
      }
    },
  },
  watch: {
    chatRecords(newVal) {//监听chatRecords的变化
      this.$nextTick(() => {
        this.scrollToBottom();
        this.renderMath();
      });
      if (newVal.length == 0) {
        this.pushGreeting();
      }
    },
  }
};
</script>

<style scoped>
.setting {
  display: flex;
  flex-direction: column;
}

.currentRoute {
  display: flex;
  font-size: 20px;
  font-size: 24px;
  margin-bottom: 15px;
  flex-direction: column;
}

.route :hover {
  color: #187EFF;
}

.chat-container {
  display: flex;
  flex-direction: column;
  background: rgb(222, 221, 221);
  border-radius: 20px;
  height: calc(100vh - 180px);
}

.chat-messages::-webkit-scrollbar {
  width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.message-container {
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 15px;

  /* Add vertical scrollbar */
  .message {
    width: fit-content;
    max-width: 706px;
    white-space: pre-wrap;
    /* 保留换行符并自动换行 */
    word-wrap: break-word;
    /* 长单词换行 */
    font-size: 16px;
  }

  /* 自定义滚动条样式 */

  /* Add styling for chat messages */
  .user {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 10px;

    .message {
      background-color: #0B48EA;
      padding: 10px;
      justify-content: flex-end;
      border-radius: 10px;
      color: white;
    }

    .icon {
      img {
        width: 32px;
        height: 32px;
      }

    }
  }

  .ai,
  .greeting {
    display: flex;
    margin-top: 30px;

    .message {
      background-color: #F4F7FF;
      display: flex;

      padding: 10px;
      justify-content: flex-start;
      margin-top: 10px;
      margin-left: 10px;
      border-radius: 10px;
    }

    .icon {
      img {
        margin-top: 10px;
        width: 32px;
        height: 32px;
      }
    }

    .waiting {
      position: absolute;
      align-items: center;
      margin-top: 20px;
      margin-left: 50px;

      img {
        width: 16px;
        height: 16px;
        -webkit-animation: rotate 1s linear infinite;
      }
    }

    @-webkit-keyframes rotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }


}

.chat-input {
  display: flex;
  flex-direction: column;
  margin: 10px;
  min-height: 120px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background: white;
  position: relative;

  /* Add styling for chat input box */
  textarea {
    outline: none;
    padding: 10px;
    width: 100%;
    height: 90px;
    border-radius: 10px;
    border-width: 0;
    resize: none;
    font-size: 16px;
    font-family: pingFangSC;
    box-sizing: border-box;
  }

  /* 自定义滚动条样式 */
  textarea::-webkit-scrollbar {
    width: 8px;
  }

  textarea::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  textarea::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  textarea::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .buttons {
    display: flex;
    position: absolute;
    width: 55px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0);
    right: 20px;
    bottom: 15px;

    img {
      cursor: pointer;
      width: 24px;
      height: 24px;
      border: 0;
      margin-right: 5px;
      margin-left: 0px;
    }

    img:hover {
      width: 26px;
      height: 26px;
    }
  }

}

.chat-input input {
  flex: 1;
  /* Add styling for input box */
}

.chat-input button {
  margin-left: 10px;
  /* Add styling for send button */
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-left: 40px;
  font-family: pingfang SC;
  font-size: 28px;
  font-weight: 600;
}

.title p {
  font-size: 14px;
  font-family: pingfang SC;
}

.title button {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  border: none;
  cursor: pointer;
}

.source button {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  border: none;
  cursor: pointer;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  .setting {
    padding: 5px;
  }

  .currentRoute {
    position: relative;
    top: auto;
    left: auto;
    font-size: 18px;
    padding: 10px;
  }

  .chat-container {
    height: calc(100vh - 160px);
    border-radius: 10px;
  }

  .chat-messages {
    padding: 10px;

    .message {
      max-width: calc(100vw - 100px);
      font-size: 14px;
    }

    .user {
      margin-right: 10px;
    }

    .ai,
    .greeting {
      margin-left: 0;
    }
  }

  .chat-input {
    min-height: 100px;
    margin: 5px;
    padding: 8px;

    textarea {
      height: 70px;
      font-size: 14px;
    }

    .buttons {
      right: 15px;
      bottom: 12px;
    }
  }

  .title {
    margin-left: 10px;
    font-size: 20px;
  }
}
</style>